export default function RadioInput({
  label,
  name,
  checked,
  onChange,
  onClick,
  disabled,
}: {
  label: string;
  name: string;
  disabled?: boolean;
  checked: boolean;
  onChange?: (isChecked: boolean) => void;
  onClick?: () => void;
}) {
  return (
    <label className="cursor-pointer flex items-center py-2 gap-2 text-gray-dark">
      <input
        type="radio"
        name={name}
        onChange={(e) => onChange && onChange(e.target.checked)}
        checked={checked}
        disabled={disabled}
        onClick={onClick}
        className="custom-form-radio cursor-pointer "
      />
      <span>{label}</span>
    </label>
  );
}
